export const enum TaskRecurrencyType {
    noRecurrency = "no recurrency",
    shifts = "shifts",
    week = "week",
    month = "month"
}


// WEBPACK FOOTER //
// ./src/Models/Tasks/TaskRecurrencies/TaskRecurrencyType.ts